export {
  calculateMultiplesValuation,
  type MultiplesValuationInput,
  type MultiplesValuationResult,
  type ConfidenceScore,
  type MarketOverrides,
  type BlendingDetails,
} from "./lib/multiples/calculate";

export {
  passiveManagementAdjustment,
  reputationAdjustment,
  cashflowVolatilityAdjustment,
  competitiveAdvantageAdjustment,
  sizeAdjustment,
  revenueTrendAdjustment,
} from "./lib/multiples/adjustments";

export {
  calculateDcfValuation,
  calculateDcfScenarios,
  type DcfValuationInput,
  type DcfHistoricalYear,
  type DcfProjectionAssumptions,
  type DcfWaccInputs,
  type DcfValuationResult,
  type DcfHistoricalOutput,
  type DcfProjectionOutput,
  type DcfScenarioInput,
  type DcfScenarioResult,
} from "./lib/dcf/calculate";

export { calculateWacc, type WaccInput, type WaccResult } from "./lib/dcf/wacc";

export {
  monteCarloSimulation,
  mulberry32,
  hashStringToSeed,
  type MonteCarloInput,
  type MonteCarloResult,
} from "./lib/dcf/monte-carlo";

export {
  sensitivityAnalysis,
  type SensitivityCell,
  type SensitivityResult,
} from "./lib/dcf/sensitivity";

export {
  calculateAssetBasedValuation,
  type AssetBasedInput,
  type AssetBasedResult,
} from "./lib/asset-based/calculate";

export {
  calculateRuleOfThumbValuation,
  type RuleOfThumbInput,
  type RuleOfThumbResult,
} from "./lib/rule-of-thumb/calculate";

export {
  runBacktest,
  DEFAULT_BACKTEST_WEIGHTS,
  type BacktestCase,
  type BacktestCaseInputs,
  type BacktestCaseResult,
  type BacktestMethod,
  type BacktestSummary,
  type MethodErrorStats,
} from "./lib/calibration/backtest";

export {
  lookupRuleOfThumb,
  type RuleOfThumbEntry,
} from "./lib/data/rule-of-thumb-multiples";

export {
  lookupSectorMultiple,
  type SectorMultiple,
} from "./lib/data/sector-multiples";

export {
  lookupWaccIndustry,
  type WaccIndustryEntry,
} from "./lib/data/wacc-industry";

export {
  ValuationValidationError,
  type ValidationError,
} from "./lib/validation";

export { lookupStateFromZip } from "./lib/geo";

export {
  normalizeSde,
  MAX_DOWNWARD_ADJUSTMENT_PCT,
  MAX_MANAGER_SALARY_REVENUE_PCT,
  type NormalizationInput,
  type NormalizedSdeResult,
  type SdeAdjustment,
} from "./lib/normalization/normalize-sde";

export {
  buildRealEstateProfile,
  shouldSeparateRealEstate,
  type RealEstateProfile,
  type RealEstateSignals,
  type RealEstateTenure,
  type RealEstateValueSource,
} from "./lib/real-estate/profile";

export {
  calculateSbaFeasibility,
  type SbaFeasibilityInput,
  type SbaFeasibilityResult,
} from "./lib/financing/sba-feasibility";

export {
  calculateLeaseValuation,
  type LeaseValuationInput,
  type LeaseValuationResult,
} from "./lib/financing/lease-valuation";

export {
  getListingPriceContext,
  type ListingPriceContext,
  type ListingPriceContextInput,
  type ListingValuationRange,
} from "./lib/listing/price-context";

export {
  computeDealModel,
  defaultDealModelInputs,
  type DealModelInputs,
  type DealModelLoan,
  type DealModelResult,
  type DealModelWarning,
  type DealModelYear,
} from "./lib/financing/deal-model";

export { DEAL_MODEL_DEFAULTS, SBA_DEFAULTS } from "./lib/financing/sba-defaults";

export {
  modelDealStructures,
  type DealStructureInput,
  type DealStructureResult,
  type DealScenario,
} from "./lib/financing/deal-structure";

export {
  analyzeTaxStructure,
  type TaxStructureInput,
  type TaxStructureResult,
  type TaxScenario,
} from "./lib/financing/tax-structure";

export {
  computeRevenueQuality,
  type RevenueQualityInput,
  type RevenueQualityResult,
  type RevenueQualityFactor,
} from "./lib/quality/revenue-quality";

export {
  detectSeasonality,
  type SeasonalityInput,
  type SeasonalityResult,
} from "./lib/quality/seasonality";

export {
  computePeerPercentile,
  type PeerPercentileInput,
  type PeerPercentileResult,
  type PeerMetricRank,
} from "./lib/quality/peer-percentile";

export {
  analyzeQualityOfEarnings,
  type QoeInput,
  type QoeResult,
  type QoeAdjustment,
} from "./lib/quality/qoe-analysis";

export {
  type ValuationMethod,
  ALL_VALUATION_METHODS,
  type MetricRequirement,
  type MethodRequirement,
  type FieldRequirement,
  METHOD_REQUIREMENTS,
  type ReportType,
  type DataDependency,
  type ReportSectionRequirement,
  type ReportRequirement,
  APPRAISAL_REPORT_REQUIREMENTS,
  CIM_REPORT_REQUIREMENTS,
  REPORT_REQUIREMENTS,
  type DataState,
  type MethodReadinessResult,
  type SectionReadiness,
  type MissingDataItem,
  type ReportReadinessResult,
  evaluateMethodReadiness,
  evaluateAllMethodReadiness,
  evaluateReportReadiness,
  evaluateAllReportReadiness,
  type MetricProvision,
  formatMetricLabel,
  getMetricsProvidedByDocTypes,
  getMethodsForDocTypes,
  getMethodsRequiringMetric,
  getMethodLabel,
} from "./lib/readiness";
